
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LottieAnimation extends Vue {
  @Prop({ type: String, required: true }) readonly animationName!: string;
  options = {
    minimizable: false,
    playerSize: 'standard',
    backgroundColor: '#fff',
    backgroundStyle: 'color',
    theme: {
      controlsView: 'standard',
      active: 'light',
      light: {
        color: '#3D4852',
        backgroundColor: '#fff',
        opacity: '0.7',
      },
      dark: {
        color: '#fff',
        backgroundColor: '#202020',
        opacity: '0.7',
      },
    },
  };
}
